// extracted by mini-css-extract-plugin
export default {"search_box":"style_search_box__SIxFz"};